import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=6727e99a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=6727e99a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6727e99a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6727e99a')) {
      api.createRecord('6727e99a', component.options)
    } else {
      api.reload('6727e99a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=6727e99a&scoped=true&", function () {
      api.rerender('6727e99a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27RGGljQP5bDY/JS/comp/SearchFilterTokens.vue"
export default component.exports